<p-dialog
  [visible]="visible"
  (visibleChange)="handleVisibleChange($event)"
  [modal]="true"
  [closable]="closable"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: width }"
  [baseZIndex]="10000"
  appendTo="body"
  [styleClass]="styleClass"
  [showHeader]="false"
>
  <div class="confirmation-dialog-content">
    <!-- Icon -->
    <div class="confirmation-dialog-icon" [class.success-icon-wrapper]="type === 'success'" [style.background-color]="type === 'success' ? getIconBgColor() : null">
      <!-- Trash Icon for Delete -->
      <svg *ngIf="type === 'delete'" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6h18" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 11v6" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 11v6" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      
      <!-- X Icon for Revoke -->
      <svg *ngIf="type === 'revoke'" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 6l12 12" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      
      <!-- Warning Icon -->
      <svg *ngIf="type === 'warning'" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="12" y1="9" x2="12" y2="13" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="12" y1="17" x2="12.01" y2="17" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      
      <!-- Info Icon -->
      <svg *ngIf="type === 'info'" width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="12" y1="16" x2="12" y2="12" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="12" y1="8" x2="12.01" y2="8" [attr.stroke]="getIconColor()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      
      <!-- Success Icon (Checkmark) -->
      <svg *ngIf="type === 'success'" data-type="success" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12l2 2 4-4" [attr.stroke]="getIconColor()" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <!-- Title -->
    <h2 class="confirmation-dialog-title">{{ title }}</h2>

    <!-- Message with HTML support -->
    <p class="confirmation-dialog-message" #messageContainer [innerHTML]="safeMessage"></p>

    <!-- Next Steps Section (for success type) -->
    <div *ngIf="type === 'success' && (nextStepsTitle || nextStepsMessage)" class="confirmation-dialog-next-steps" [style.background-color]="getNextStepsBgColor()">
      <div class="next-steps-icon" [style.background-color]="getButtonColor()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8v4l3 3" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="next-steps-content">
        <h3 class="next-steps-title" *ngIf="nextStepsTitle" [style.color]="getNextStepsAccentColor()">{{ nextStepsTitle }}</h3>
        <p class="next-steps-message" *ngIf="nextStepsMessage" [style.color]="getNextStepsAccentColor()">{{ nextStepsMessage }}</p>
      </div>
    </div>

    <!-- Buttons -->
    <div class="confirmation-dialog-actions">
      <button
        *ngIf="showSecondaryAction && secondaryActionLabel"
        type="button"
        class="confirmation-dialog-btn confirmation-dialog-btn--secondary"
        (click)="handleSecondaryAction()"
        [disabled]="loading"
      >
        {{ secondaryActionLabel }}
      </button>
      <button
        *ngIf="showCancelButton && !showSecondaryAction"
        type="button"
        class="confirmation-dialog-btn confirmation-dialog-btn--cancel"
        (click)="handleCancel()"
        [disabled]="loading"
      >
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        class="confirmation-dialog-btn confirmation-dialog-btn--confirm"
        [style.background-color]="getButtonColor()"
        [style.box-shadow]="'0 4px 6px -1px ' + getButtonColor() + '4d'"
        [attr.data-theme-color]="themeColor"
        (click)="handleConfirm()"
        [disabled]="loading || confirmDisabled"
      >
        <span *ngIf="loading">Processing...</span>
        <span *ngIf="!loading">{{ confirmLabel }}</span>
      </button>
    </div>
  </div>
</p-dialog>

